/* eslint-disable semi */
/* eslint-disable comma-dangle */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import baseurl from '../../@core/auth/jwt/baseurl'

export const getAlllookups = createAsyncThunk('appLookups/getAlllookups', async () => {
  const response = await baseurl.get('api/app/lookup/lookups')
  return {
    data: response.data
  }
})

export const appLookups = createSlice({
  name: 'appLookups',
  initialState: {
    data: {},
    loading: true
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAlllookups.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.loading = false
    })
  }
})

export default appLookups.reducer
